function bindCampaignLabelClickListener() {
  $('.label').click(function () {
    var span = $(this);
    if (span.hasClass('label-default')) {
      span.addClass('label-primary').removeClass('label-default').find('input').prop('checked', true);
    } else if (span.hasClass('label-primary')) {
      span.addClass('label-default').removeClass('label-primary').find('input').prop('checked', false);
    }
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindCampaignLabelClickListener;